module.exports = __webpack_public_path__ + "static/media/Layout23.7015fa6f.png";